// ── Orchestrateur suggestions ─────────────────────────────────────────────────
//
// Ce module s'abonne à l'événement 'usito:suggestions-reçues' déclenché par usito.js.
// Il est conçu pour fonctionner indépendamment de usito.js — aucun couplage direct.
//
// Chargement : via l'entry point usito-paquet.js (toutes les pages).

import { updateSuggestionResultsHTML } from './ui.js';

document.addEventListener('usito:suggestions-reçues', function({ detail }) {
    updateSuggestionResultsHTML(detail.résultats, detail.texte);
});
